import MatomoOptOut from "../components/matomo";
function Datenschutz() {

  return (
    <div className="container mt-4 background">
      <h1>Datenschutzerklärung</h1>

      <h2 id="m716">Präambel</h2>
      <p>
        Mit der folgenden Datenschutzerklärung informiere ich darüber, welche
        Arten personenbezogener Daten (nachfolgend "Daten") ich zu welchen
        Zwecken und in welchem Umfang verarbeite. Die Datenschutzerklärung gilt
        für alle von mir durchgeführten Verarbeitungen personenbezogener Daten
        im Rahmen meines Onlineangebots, einschließlich meiner Webseiten sowie
        externer Onlinepräsenzen.
      </p>
      <p>Die verwendeten Begriffe sind nicht geschlechtsspezifisch.</p>

      <p>Stand: 2. Dezember 2025</p>

      <h2>Inhaltsübersicht</h2>
      <ul className="index">
        <li>
          <a className="index-link" href="#m716">
            Präambel
          </a>
        </li>
        <li>
          <a className="index-link" href="#m3">
            Verantwortlicher
          </a>
        </li>
        <li>
          <a className="index-link" href="#mOverview">
            Übersicht der Verarbeitungen
          </a>
        </li>
        <li>
          <a className="index-link" href="#m2427">
            Maßgebliche Rechtsgrundlagen
          </a>
        </li>
        <li>
          <a className="index-link" href="#m27">
            Sicherheitsmaßnahmen
          </a>
        </li>
        <li>
          <a className="index-link" href="#m12">
            Allgemeine Informationen zur Datenspeicherung und Löschung
          </a>
        </li>
        <li>
          <a className="index-link" href="#m10">
            Rechte der betroffenen Personen
          </a>
        </li>
        <li>
          <a className="index-link" href="#m225">
            Bereitstellung des Onlineangebots und Webhosting
          </a>
        </li>
        <li>
          <a className="index-link" href="#m134">
            Einsatz von Cookies / Consent
          </a>
        </li>
        <li>
          <a className="index-link" href="#matomo">
            Matomo Webanalyse
          </a>
        </li>
        <li>
          <a className="index-link" href="#m328">
            Plug-ins und eingebettete Inhalte (Spotify)
          </a>
        </li>
      </ul>

      <h2 id="m3">Verantwortlicher</h2>
      <p>
        Valeria Peschke
        <br />
        Strelitzstr. 12
        <br />
        12105 Berlin
      </p>
      <p>
        E-Mail-Adresse:{" "}
        <a href="mailto:peschkeva@gmail.com">peschkeva@gmail.com</a>
      </p>

      <h2 id="mOverview">Übersicht der Verarbeitungen</h2>
      <p>
        Die nachfolgende Übersicht fasst die verarbeiteten Datenarten und ihre
        Zwecke zusammen.
      </p>

      <h3>Arten der verarbeiteten Daten</h3>
      <ul>
        <li>Nutzungsdaten.</li>
        <li>Meta-, Kommunikations- und Verfahrensdaten.</li>
        <li>Protokolldaten.</li>
      </ul>

      <h3>Kategorien betroffener Personen</h3>
      <ul>
        <li>Nutzer.</li>
      </ul>

      <h3>Zwecke der Verarbeitung</h3>
      <ul>
        <li>Sicherheitsmaßnahmen.</li>
        <li>Bereitstellung meines Onlineangebotes.</li>
        <li>Informationstechnische Infrastruktur.</li>
        <li>Reichweitenmessung / Webanalyse (Matomo).</li>
      </ul>

      <h2 id="m2427">Maßgebliche Rechtsgrundlagen</h2>
      <p>
        <strong>Rechtsgrundlagen nach der DSGVO:</strong>
      </p>
      <ul>
        <li>
          <strong>Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)</strong> – beim
          Laden von Spotify-Inhalten über mein Consent-Banner.
        </li>
        <li>
          <strong>Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO)</strong> –
          technischer Betrieb, Sicherheit, sowie cookielose Reichweitenmessung
          mit Matomo.
        </li>
      </ul>

      <p>
        <strong>Nationale Regelungen:</strong> Zusätzlich gelten das BDSG und
        ggf. landesrechtliche Vorgaben.
      </p>

      <h2 id="m27">Sicherheitsmaßnahmen</h2>
      <p>
        Ich treffe technische und organisatorische Maßnahmen gemäß gesetzlichen
        Vorgaben, um ein dem Risiko angemessenes Schutzniveau zu gewährleisten.
      </p>
      <p>
        Dazu gehören Zugriffskontrollen, Datensicherungen, Schutz vor unbefugtem
        Zugriff sowie regelmäßige technische Anpassungen.
      </p>
      <p>
        <strong>TLS-/SSL-Verschlüsselung (HTTPS):</strong> Meine Website nutzt
        HTTPS.
      </p>

      <h2 id="m12">
        Allgemeine Informationen zur Datenspeicherung und Löschung
      </h2>
      <p>Ich lösche personenbezogene Daten gemäß gesetzlichen Anforderungen.</p>
      <p>Es gelten u. a. folgende Fristen:</p>
      <ul>
        <li>10 Jahre – steuer- und handelsrechtliche Unterlagen.</li>
        <li>8 Jahre – Buchungsbelege.</li>
        <li>6 Jahre – handelsrelevante Korrespondenz.</li>
        <li>3 Jahre – mögliche zivilrechtliche Ansprüche.</li>
      </ul>

      <h2 id="m10">Rechte der betroffenen Personen</h2>
      <ul>
        <li>Widerspruchsrecht (Art. 21 DSGVO).</li>
        <li>Widerruf von Einwilligungen (Art. 7 Abs. 3 DSGVO).</li>
        <li>Auskunft (Art. 15 DSGVO).</li>
        <li>Berichtigung (Art. 16 DSGVO).</li>
        <li>Löschung (Art. 17 DSGVO).</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO).</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO).</li>
        <li>Beschwerde bei der Datenschutzbehörde.</li>
      </ul>

      <h2 id="m225">Bereitstellung des Onlineangebots und Webhosting</h2>
      <p>
        Ich nutze <strong>ALL-INKL.COM</strong> zum Hosting meiner Website.
        ALL-INKL erstellt Server-Logfiles mit:
      </p>
      <ul className="m-elements">
        <li>IP-Adresse</li>
        <li>Datum und Uhrzeit des Abrufs</li>
        <li>Browsertyp und -version</li>
        <li>Betriebssystem</li>
        <li>Referrer URL</li>
        <li>Hostname des zugreifenden Rechners</li>
      </ul>
      <p>
        Ich nutze diese Logdaten ausschließlich für technische Sicherheit,
        Systemstabilität und Fehleranalysen. Keine Profilbildung, kein Tracking,
        keine Statistik.
      </p>

      <h2 id="m134">Einsatz von Cookies / Consent-Banner</h2>
      <p>
        Ich nutze kein externes Tool wie Complianz. Stattdessen verwende ich ein
        eigenes Consent-Banner auf Basis von{" "}
        <strong>react-cookie-consent</strong>.
      </p>
      <p>
        Das Banner speichert ausschließlich, ob Sie der Einbindung von Spotify
        zugestimmt haben.
      </p>
      <p>
        Ohne Einwilligung:{" "}
        <strong>
          Keine Spotify-Verbindung, keine Cookies, keine Datenübertragung.
        </strong>
      </p>

      {/* MATOMO SECTION */}
      <h2 id="matomo">Matomo Webanalyse</h2>
      <p>
        Ich nutze <strong>Matomo</strong> zur Reichweitenmessung meiner Website.
        Die Verarbeitung erfolgt auf meinem eigenen Server (oder einem Server
        innerhalb der EU), sodass keine Daten an Dritte weitergegeben werden.
      </p>
      <p>
        Matomo wird von mir <strong>cookielos</strong> betrieben. Es werden
        keine personenbezogenen Profile erstellt, keine Cookies gesetzt und
        keine Nutzer-IDs generiert.
      </p>

      <p>Folgende anonymisierte Daten können erfasst werden:</p>
      <ul>
        <li>gekürzte IP-Adresse</li>
        <li>Besuchszeitpunkt</li>
        <li>aufgerufene Seiten</li>
        <li>Verweildauer</li>
        <li>technische Daten (Browser, Betriebssystem)</li>
        <li>Referrer (zuvor besuchte Seite)</li>
      </ul>

      <p>
        Ich nutze Matomo auf Grundlage meines berechtigten Interesses an einer
        anonymen Reichweitenanalyse gemäß Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <h3>Webanalyse mit Matomo</h3>
      <p>
        Ich nutze Matomo, eine Open-Source-Software zur anonymisierten Analyse
        der Nutzung meiner Website. Dabei werden keine personenbezogenen Daten
        gespeichert, sondern die Zugriffe ausschließlich in anonymisierter Form
        ausgewertet. So kann ich besser verstehen, wie du meine Seite nutzt, und
        mein Angebot für dich verbessern.
      </p>

      <h3>Opt-Out</h3>
      <p>
        Du kannst der anonymen Erfassung jederzeit widersprechen. Wenn du hier
        das Opt-Out aktivierst, wird ein Cookie gesetzt, das die Erfassung
        deiner Besuche verhindert. Bitte denk daran: Wenn du deine Cookies
        löschst, musst du das Opt-Out erneut aktivieren.
      </p>

      <div id="matomo-opt-out"></div>
<MatomoOptOut />
      <h2 id="m328">Plug-ins und eingebettete Inhalte (Spotify)</h2>
      <p>
        Ich binde Inhalte der <strong>Spotify AB</strong> ein. Diese werden erst
        geladen, wenn Sie zugestimmt haben.
      </p>
      <p>Dabei können übertragen werden:</p>
      <ul>
        <li>IP-Adresse</li>
        <li>Browser- und Geräteinformationen</li>
        <li>Nutzungsdaten des Spotify-Players</li>
      </ul>
      <p>
        Spotify kann eigene Cookies verwenden.
        <br />
        Datenschutz: https://www.spotify.com/de/legal/privacy-policy/ <br />
        Cookies: https://www.spotify.com/de/legal/cookies-policy/
      </p>

      <h3>Google Fonts (lokal eingebunden)</h3>
      <p>
        Ich verwende Google Fonts ausschließlich lokal. Es wird keine Verbindung
        zu Google-Servern hergestellt und es werden keine Google-Daten
        übertragen.
      </p>

      <br />
      <br />
    </div>
  );
}

export default Datenschutz;
